module.exports = __webpack_public_path__ + "04-login.jpg?cddf7d9a058a381a2105073cb83da4d6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04-login.jpg
// module id = 683
// module chunks = 0